/**
 * #40291 Determines if a serie or underlying data source is in an error state
 * so that it can be properly portrayed in the UI
 *
 * @param {ChartDesignerSerie} serie the serie to check for an error state
 * @param {ChartDesigner} chartData chart the chart designer that data source
 * 						  metadata can be retrieved from
 */
function isSerieInErrorState(serie, chart) {
	const source = serie.get('source')
	if (source.domainType === 'dataset') {
		// Check for an error in the source dataset
		const datasetId = source.aggregation.startingDatasetId
		const dataset = chart.data.datasetModel(datasetId)
		if (dataset && dataset.get('errorCode')) {
			return true
		}
	}
	return false
}

export default isSerieInErrorState
isSerieInErrorState.__filename__ = 'charts/is-serie-in-error-state.js'
